export const RecommendationLinesColumns = [
    {
        name: "Nome da Linha Favoritada",
        id: "lineGrantsName"
    },
    {
        name: "Orçamento dos Projetos",
        id: "budget"
    }
];